module.exports = __webpack_public_path__ + "static/media/6.168e0607.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Artists/01/projects/01/6.jpg
// module id = 397
// module chunks = 0